<template>
    <div>
        <div class="row mt-3">
            <div class="col-lg-1 col-12 mt-3 d-inline-block"></div>
            <div class="col-lg-2 col-12 mt-3 d-inline-block">
                <h4>دریافت از (بستانکار)</h4>
            </div>
            <div class="col-lg-4 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">سرفصل</span>
                    </div>
                    <vs-select :data="mainAccounts" :mode="'create'"
                               :selected-val="mainSel1"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onDept1Select"></vs-select>
                </div>
            </div>
            <div class="col-lg-4 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">زیر سرفصل :</span>
                    </div>
                    <vs-select :data="cashs1" :mode="'create'"
                               :selected-val="secSell1"
                               :header="{multiple: false, label: 'outSourceName'}"
                               @onChange="onDept2Select"></vs-select>
                </div>
            </div>


            <div class="col-lg-1 col-12 mt-3 d-inline-block"></div>
            <div class="col-lg-1 col-12 mt-3 d-inline-block"></div>

            <div class="col-lg-2 col-12 mt-3 d-inline-block">
                <h4>واریز به (بدهکار)</h4>
            </div>
            <div class="col-lg-4 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">سرفصل</span>
                    </div>
                    <vs-select :data="mainAccounts" :mode="'create'"
                               :header="{multiple: false, label: 'title'}"
                               :selected-val="mainSel2"
                               @onChange="onCreat1Select"></vs-select>
                </div>
            </div>
            <div class="col-lg-4 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">زیر سرفصل :</span>
                    </div>
                    <vs-select :data="cashs2" :mode="'create'"
                               :header="{multiple: false, label: 'outSourceName'}"
                               :selected-val="secSell2"
                               @onChange="onCreat2Select"></vs-select>
                </div>
            </div>
            <div class="col-lg-1 col-12 mt-3 d-inline-block"></div>
            <div class="col-lg-1 col-12 mt-3 d-inline-block"></div>
            <div class="col-lg-3 col-12 mt-3 d-inline-block">

                <div class="input-group mt-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text">مبلغ</span>
                    </div>
                    <input class="form-control" type="number"
                           v-model="activePayment.price" placeholder="مبلغ" @input="thousandSeprator(activePayment.price)">
                </div>
                <small class="text-nowrap mt-2">{{activePayment.priceShow}}</small>
            </div>
            <div class="col-lg-6 col-12 mt-3 d-inline-block">
                <div class="input-group mt-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text">توضیحات</span>
                    </div>
                    <input class="form-control" type="text"
                           v-model="activePayment.description" placeholder="توضیحات">
                </div>
            </div>
            <div class="col-lg-1 col-12 mt-3 d-inline-block">
                <button type="button" class="btn btn-success mt-2 w-100" @click="onPaymentModalOk">ثبت</button>
            </div>


        </div>


        <div class="modal fade" id="transaction" tabindex="-1" role="dialog" aria-labelledby="transactionTitle"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger-grad glow-danger">
                        <h5 class="modal-title text-white" id="transactionTitle">خلاصه تراکنش</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="table-responsive modal-body" id="printMe">
                        <table class="table table-bordered">
                            <tbody>
                            <tr>
                                <td>
                                    <strong>دریافت از (بستانکار)</strong>
                                </td>
                                <td>
                                    <span>{{secSell1}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>واریز به (بدهکار)</strong>
                                </td>
                                <td>
                                    <span>{{secSell2}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>مبلغ</strong>
                                </td>
                                <td>
                                    <!--<span>{{activePayment.price.toLocaleString()}}</span>-->
                                    <span>{{thousandSepratorprint(activePayment.price)}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>توضیحات</strong>
                                </td>
                                <td>
                                    <!--<span>{{activePayment.price.toLocaleString()}}</span>-->
                                    <input class="form-control" type="text" v-model="activePayment.description">
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>تاریخ</strong>
                                </td>
                                <td>
                                    <div class="input-group mt-2">
                                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                                     ref="datePickerStart" style="flex: 1">
                                            <slot>
                                                <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                                       @click="toggleStartDatePicker">
                                                <button class="close reset-date" @click="resetStartDate">×</button>
                                            </slot>
                                        </date-picker>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="d-inline-block btn btn-success m-1" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onConfirmationModalOk">تایید</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect"
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from 'moment-jalali';
    import VueHtmlToPaper from 'vue-html-to-paper';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'accountPayment',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {

                banks: [],
                cashDesks: [],
                checkBooks: [],

                transactionType: "",
                remainingAmount: 0,

                activePayment: {
                    code: "",
                    price: 0,
                    name: "",
                    check: {
                        checkNumber: "",
                        checkDate: "",
                        checkPersianDate: "",
                        bankName: "",
                        branchName: "",
                        branchCode: ""
                    },
                    voucherDate: "0001-01-01",
                    fromCode: "",
                    toCode: "",
                    description: "",


                },

                hasCheck: false,
                archivedVoucher: false,
                customerChecks: [],

                payments: [],
                customers: [],


                queryParams: {
                    pageSize: 10000,
                    pageIndex: 0,

                },
                queryParams1: {
                    pageSize: 10000,
                    pageIndex: 0,
                    parrentId: 1
                },
                queryParams2: {
                    pageSize: 10000,
                    pageIndex: 0,
                    parrentId: 1
                },
                selectedMain1: 0,
                selectedMain2: 0,
                selectedCash1: 0,
                selectedCash2: 0,
                keepData: false,
                showCash: false,
                isDetail: false,
                mainSel1: "",
                mainSel2: "",
                secSell1: "",
                secSell2: "",

                fromTitle: "",
                toTitle: "",
                isSending: false,

                voucherDatePersian: "",
                mainAccounts: [
                    {id: 0, title: "همه حسابها"},
                    {id: 1, title: "بانکها"},
                    {id: 2, title: "صندوق ها"},
                    {id: 3, title: "مشتری ها"},
                    {id: 5, title: "تامین کننده ها"},
                    {id: 6, title: "سرمایه(موجودی اولیه)"},
                    {id: 7, title: "درآمدها"},
                    {id: 8, title: "هزینه ها"},
                    // {id: 9, title: "تولید"},
                    {id: 10, title: "فروش"},
                    {id: 11, title: "خرید"},
                    {id: 12, title: "چک های دریافتی"},
                    {id: 13, title: "چک های پرداختی"},
                    {id: 20, title: "سایر سرفصلها"},
                    // {id: 14, title: "فروش اینترنتی"},
                ],
                cashs1: [],
                cashs2: [],
                showprice: 0,
            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);


            let tod = Moment(new Date()).format('YYYY-MM-DD');
            this.activePayment.voucherDate = tod;
            this.voucherDatePersian = Moment(tod, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
        },
        methods: {
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },

            findCode(mainText) {
                let code = mainText.substring(0, mainText.indexOf("9"));
                switch (parseInt(code)) {
                    case 1:
                        return "بانک";
                    case 2:
                        return "صندوق";
                    case 3:
                        return "مشتری";

                    case 5:
                        return "تامین کننده";
                    // case 6:
                    //    return "بانک";
                    case 7:
                        return "درآمد";
                    case 8:
                        return "هزینه";
                    // case 10:
                    //    return "بانک";
                    // case 11:
                    //    return "بانک";
                    // case 12:
                    //    return "بانک";
                    // case 13:
                    //    return "بانک";
                    case 14:
                        return "خرید آنلاین";
                }
            },
            onCardClicked(e, index, type) {
                this.activePayment.name = "";
                this.activePayment.code = "";
                this.activePayment.price = 0;
                if (type === 'bank') {
                    this.activePayment.name = this.banks[index].outSourceName;
                    this.activePayment.code = this.banks[index].code;
                    this.activePayment.usedCheck = false;
                    if (this.fromTitle === "") {
                        this.fromTitle = "بانک";
                    } else {
                        this.toTitle = "بانک";
                    }
                    $("#payment").modal("show");
                }
                if (type === 'cashDesk') {
                    this.activePayment.name = this.cashDesks[index].outSourceName;
                    this.activePayment.code = this.cashDesks[index].code;
                    this.activePayment.usedCheck = false;
                    if (this.fromTitle === "") {
                        this.fromTitle = "صندوق";
                    } else {
                        this.toTitle = "صندوق";
                    }
                    $("#payment").modal("show");
                }
                if (type === 'checkBook') {
                    this.activePayment.name = this.checkBooks[index].outSourceName;
                    this.activePayment.code = this.checkBooks[index].code;
                    this.activePayment.price = this.checkBooks[index].price;
                    this.activePayment.usedCheck = true;
                    if (this.fromTitle === "") {
                        this.fromTitle = "چک";
                    } else {
                        this.toTitle = "چک";
                    }
                    this.onPaymentModalOk();
                }
                /*for (let item of this.payments) {
                    if (item.code === this.activePayment.code) {
                        this.activePayment.price = item.price;
                    }
                }*/
            },
            /*onModalShow() {
                $("#voucherData").modal("show");
            },
            onModalEditClicked() {
                $("#voucherData").modal("hide");
                if (this.transactionType === "buy") {
                    let obj = {
                        name: 'buy-from-outsource',
                        params: {
                            id: this.voucher.serveOutSourceId,
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                } else {
                    let obj = {
                        name: 'sell',
                        params: {
                            voucher: this.voucher
                        }
                    };
                    this.$router.push(obj);
                }
            },*/
            onPaymentModalOk() {
                /*let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.price = parseInt(payment.price);
                //this.remainingAmount -= payment.price;
                //this.activePayment.price = parseInt(this.activePayment.price);
                if (this.payments.length < 1) {
                    this.payments.push(payment);
                } else {
                    let flag = false;
                    for (let item of this.payments) {
                        if (item.code === payment.code) {
                            item.price = payment.price;
                            flag = true;
                        }
                    }
                    if (flag === false) {
                        this.payments.push(payment);
                    }
                }
                this.activePayment.price = 0;
                $("#payment").modal("hide");*/
                $("#payment").modal('hide');
                $("#transaction").modal('show');

                /*if (this.activePayment.check.checkNumber === "") {
                    this.activePayment.check = null;
                }
                new BaseService('payment').create(this.activePayment).then(response => {
                    this.$noty.success("تراکنش با موفقیت ثبت شد!");
                    if (this.transactionType === 'payment') {
                        this.$router.push({name: 'payment-report'});
                    } else {
                        this.$router.push({name: 'receive-report'});
                    }

                    $("#payment").modal('hide');
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                })*/
            },
            onConfirmationModalOk() {
                if (this.activePayment.voucherDate === undefined || this.activePayment.voucherDate === null ||this.activePayment.voucherDate === "" || this.activePayment.voucherDate === "0001-01-01") {
                    this.activePayment.voucherDate =  Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.activePayment.voucherDate)) {
                    if (this.activePayment.fromCode === "") {
                        this.$noty.error("لطفا پرداخت کننده را انتخاب کنید.");
                    } else if (this.activePayment.toCode === "") {
                        this.$noty.error("لطفا دریافت کننده را انتخاب کنید.");
                    } else if (this.activePayment.price === 0) {
                        this.$noty.error("لطفا مبلغ را وارد کنید.");
                    } else {
                        if (!this.isSending) {
                            this.isSending = true;
                            if (this.activePayment.check != null && this.activePayment.check !== undefined) {
                                if (this.activePayment.check.checkNumber === "") {
                                    this.activePayment.check = null;
                                }
                            }
                            new BaseService('payment').create(this.activePayment).then(response => {
                                this.$noty.success("تراکنش با موفقیت ثبت شد.");
                                this.isSending = false;
                                $("#transaction").modal('hide');
                                this.activePayment.fromCode = "";
                                this.activePayment.toCode = "";
                                this.activePayment.price = 0;
                                this.activePayment.priceShow = "";
                                this.activePayment.description = "";
                                this.selectedMain1 = "";
                                this.mainSel1 = "";
                                this.mainSel2 = "";
                                this.secSell1 = "";
                                this.selectedMain2 = "";
                                this.secSell2 = "";
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            });
                        }
                    }
                }
            },
            onRemovePaymentClicked(index) {
                this.payments.splice(index, 1);
            },
            /*isActive(object) {
                for (let item of this.payments) {
                    if (item.code === object.code) {
                        return true;
                    }
                }
                return false;
            },*/
            onBankChange(val) {
                this.toTitle = "دریافت چک";
                this.activePayment.check.bankName = val.name;
                this.activePayment.check.rowVersion = this.generateUuid();
            },
            onBankChange2(val) {
                this.fromTitle = "دسته چک بانک " + val.outSourceName;
                // if (this.transactionType === 'payment') {
                this.activePayment.check.checkExporterBankId = val.id;
                this.activePayment.check.rowVersion = this.generateUuid();
                // } else {
                //     this.activePayment.check.checkExporterBankId = val.id;
                // }
            },
            toggleDatePicker() {
                this.$refs.datePicker.togglePicker();
            },
            onDatePicked(val) {
                this.activePayment.check.checkDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.activePayment.check.checkPersianDate = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetDate() {
                this.activePayment.check.checkPersianDate = '';
                this.activePayment.check.checkDate = '';
            },
            onCheckModalOk() {
                let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.price = parseInt(payment.price);
                this.payments.push(payment);
                if (this.transactionType === 'sell') {
                    this.hasCheck = true;
                }
                // this.customerChecks.push(payment);
                Utils.resetObject(this.activePayment.check);
                // this.activePayment.price = 0;
                this.activePayment.code = "";

                // let payment = JSON.parse(JSON.stringify(this.activePayment));
                payment.check.rowVersion = this.generateUuid();
                this.activePayment.usedCheck = true;
                this.activePayment.code = null;
                this.activePayment.check = payment.check;
                $("#check").modal('hide');
                this.onPaymentModalOk();
            },
            onTransactionSubmitClicked() {
                if (this.voucher.voucherDate === undefined || this.voucher.voucherDate === null ||this.voucher.voucherDate === "" || this.voucher.voucherDate === "0001-01-01") {
                    this.voucher.voucherDate =  Moment(new Date()).format('YYYY-MM-DD');
                }
                if (this.checkVoucherDateInSalemali(this.voucher.voucherDate)) {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (isNaN(this.voucher.receiveOutSourceId)) {
                            this.voucher.receiveOutSourceId = "";
                        }
                        for (let item of this.payments) {
                            if (item.check.checkNumber === "") {
                                item.check = null;
                            }
                        }
                        new BaseService('voucher').create(this.voucher).then(response => {
                            let voucherId = response.data.data;
                            new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                                this.$noty.success("سند با موفقیت ثبت شد!");
                                if (this.archivedVoucher) {
                                    this.removeVoucherFromArchives(this.voucher.type, this.voucher.voucherIndex);
                                }
                                $("#customer").modal("hide");
                                this.$router.push({name: 'home'});
                            }).catch(error => {
                                Utils.handleErrorWithNotification(error.response.message, this.$noty);
                            })
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }
                }
            },
            onCustomerAssignmentClicked() {
                if (this.remainingAmount < 0) {
                    this.$noty.error("مبلغ باقیمانده منفی میباشد!")
                } else {
                    this.queryParams.types = 1;
                    new BaseService('outsource', '/getlist').getList(this.queryParams).then(response => {
                        this.customers = response.data.data;
                        $("#loading-customer").hide();
                        $("#customer").modal("show");
                    }).catch(error => {
                        // error
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                }
            },
            onCustomerClicked(index) {
                this.voucher.receiveOutSourceId = this.customers[index].id;
                this.onVoucherSubmitClicked();
            },
            removeVoucherFromArchives(type, index) {
                if (type === 'buy') {
                    let archives = JSON.parse(localStorage.getItem("tempVoucherBuy"));
                    archives.splice(index, 1);
                    localStorage.setItem("tempVoucherBuy", JSON.stringify(archives));
                } else {
                    let archives = JSON.parse(localStorage.getItem("tempVoucherSell"));
                    archives.splice(index, 1);
                    localStorage.setItem("tempVoucherSell", JSON.stringify(archives));
                }
            },
            thousandSeprator(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                this.activePayment.priceShow = showprice;

            },
            thousandSepratorprint(a) {

                let amount = a;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                return showprice;

            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            onStartDatePicked(val) {
                this.activePayment.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.activePayment.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },
            onDept1Select: function (val) {
                if (val && val.id) {
                    this.mainSel1 = val.title;

                    if (val.id === 0) {
                        this.selectedMain1 = val.id;
                        this.queryParams.outsourceType = this.selectedMain1;
                    } else {
                        this.selectedMain1 = val.id;
                        this.queryParams1.outsourceType = this.selectedMain1;

                    }
                    this.queryParams1.pageIndex = 0;
                    this.queryParams1.types = this.selectedMain1;
                    this.getProviders1();
                }
            },
            onDept2Select(val) {
                if (val && val.id) {
                    this.secSell1 = val.outSourceName;
                    this.activePayment.fromCode = null;
                    this.activePayment.code = val.code;
                }

            },
            getProviders1() {
                new BaseService('outsource', '/getlist').getList(this.queryParams1).then(response => {
                    this.cashs1 = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },

            onCreat1Select: function (val) {
                if (val && val.id) {
                    this.mainSel2 = val.title;
                    if (val.id === 0) {
                        this.selectedMain2 = val.id;
                        this.queryParams.outsourceType = this.selectedMain2;
                    } else {
                        this.selectedMain2 = val.id;
                        this.queryParams2.outsourceType = this.selectedMain2;

                    }
                    this.queryParams2.pageIndex = 0;
                    this.queryParams2.types = this.selectedMain2;
                    this.getProviders2();
                }

            },
            onCreat2Select(val) {
                if (val && val.id) {
                    this.secSell2 = val.outSourceName;
                    this.activePayment.toCode = val.code;
                    console.log("sdsdssdfsd", this.secSell2)
                }

            },
            getProviders2() {
                new BaseService('outsource', '/getlist').getList(this.queryParams2).then(response => {
                    this.cashs2 = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    console.log(error)
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },


        },

        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#payment").hasClass("show")) {
                $("#payment").modal("hide");
                next(false);
            } else {
                if ($("#check").hasClass("show")) {
                    $("#check").modal("hide");
                    next(false);
                } else {
                    if ($("#customer").hasClass("show")) {
                        $("#customer").modal("hide");
                        next(false);
                    } else {
                        if ($("#transaction").hasClass("show")) {
                            $("#transaction").modal("hide");
                            next(false);
                        } else {
                            next();
                        }
                    }
                }
            }


        },
    }
</script>